var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},_vm._l((_vm.items),function(item){return _c('button',{key:item.code,staticClass:"tabs__button",class:{ tabs__button_active: _vm.modelValue === item.code },attrs:{"type":"button"},on:{"click":function($event){return _vm.handleClickTab(item.code)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }